import LaunchIcon from '@mui/icons-material/Launch';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { BannerDataLegacy } from '../../api/types';
import { NormalLinkWrapper } from '../LinkWrapper/NormalLinkWrapper';

interface BannerProps {
    banner: BannerDataLegacy;
    translations: Record<string, string>;
}

export const Banner: React.FC<BannerProps> = ({ banner, translations }) => (
    <Box mb={2}>
        <NormalLinkWrapper to={banner.link} translations={translations}>
            <Alert
                variant="outlined"
                severity="info"
                style={{
                    alignItems: 'center',
                }}
            >
                <Typography variant="h6">
                    {banner.title} <LaunchIcon style={{ fontSize: '0.95rem' }} />
                </Typography>
                <Typography color="textSecondary" variant="body2">
                    {banner.message}
                </Typography>
            </Alert>
        </NormalLinkWrapper>
    </Box>
);
